import DocumentTypes, { documentTypeInitialValue } from './documentType';

export default class OtherDocuments {
  documentTypeSelected: DocumentTypes = documentTypeInitialValue;
  id: string = '';
  creationDate?: string | null = '';
  expirationDate: string = '';
  documentType = 0;
  observation: string = '';
  note: string = '';
  attachment = new File([], '') || null;
  fileName = '';
  url = '';
}
